import React, { useState } from 'react'
import FeedBackForm from './feedbackForm'
import useToggle from '../hooks/useToggle'
import SendIcon from '../assets/sendIcon'

interface CloseWidgetProps {
    config: any
    closeWidget: () => void
    goBack: () => void
    send: (msg: string, payload: string, options?: any) => void
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
}

const CloseWidget: React.FC<CloseWidgetProps> = ({ config, closeWidget, goBack, send, mainSizing }) => {
    const [showFeedbackForm, toggleShowFeedbackForm] = useToggle(false)
    const [backAnimation, toggleBackAnimation] = useToggle(false)
    const [emailAddress, setEmailAddress] = useState('')
    const [emailSent, setEmailSent] = useState(false)

    const { buttons_bg_color, buttons_text_color } = config

    const onEmailInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmailAddress(event.target.value.trim())
    }

    const sendTranscriptEmail = () => {
        if (!validateEmail(emailAddress)) {
            return
        }
        send('', emailAddress, { msg_type: 'transcript_request' })
        setEmailSent(true)
        setEmailAddress('')
        setTimeout(() => {
            setEmailSent(false)
        }, 4000)
    }

    const validateEmail = (email: string) => {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    }

    const goBackWithAnimation = () => {
        toggleBackAnimation(true)
        setTimeout(() => {
            goBack()
            toggleBackAnimation(false)
        }, 480)
    }

    const handleGoBack = (submitted: boolean) => {
        if (submitted) {
            closeWidget()
        } else {
            toggleShowFeedbackForm(false)
        }
    }

    const newWidth = mainSizing.width === '50vw' ? 'calc(50vw - 25px)' : `calc(${mainSizing.width} - 15px)`

    return (
        <div className={backAnimation ? 'widgetMenuOverlayfadeOut' : 'widgetMenuOverlay'}>
            <div
                className='widgetMenu closeWidget'
                style={{ width: newWidth, height: `calc(${mainSizing.height} + 25px)`, color: 'black', backgroundColor: 'white' }}
            >
                {showFeedbackForm ? (
                    <FeedBackForm
                        config={config}
                        closeFeedbackForm={handleGoBack}
                        send={send}
                        mainSizing={mainSizing}
                        closeWidget={closeWidget}
                    />
                ) : (
                    <div className='feedbackContainer'>
                        <h3>Before you go</h3>
                        <p>Please give us feedback to help us improve AccessAva.</p>
                        <div className='feedbackButtons'>
                            <button
                                onClick={toggleShowFeedbackForm}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Give feedback
                            </button>
                            <button
                                onClick={goBackWithAnimation}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Go Back
                            </button>
                            <button
                                onClick={closeWidget}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Close (deletes chat)
                            </button>
                        </div>
                        <i>
                            To receive a copy of your conversation, add your email here:{' '}
                        </i>
                        <div className='widgetMenuEmailForm'>
                            <input
                                placeholder='Enter email address'
                                value={emailAddress}
                                onChange={onEmailInputChange}
                            ></input>
                            <button
                                className='sendEmailBtn'
                                type='button'
                                onClick={sendTranscriptEmail}
                            >
                                <SendIcon stroke='black' />
                            </button>
                        </div>
                        {emailSent && <div className='widgetMenuEmailSent'>Transcript has been sent to the email address provided</div>}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CloseWidget
